import React, { useEffect } from "react";
import "./checkbox.css";

export default function Checkbox(props) {
  const { value, formikSetFieldValue, id, name, extra } = props;

  useEffect(() => {}, [value]);

  return (
    <span className="checkbox" key={id + "_content"}>
      <input
        id={id}
        name={name}
        type="checkbox"
        checked={value}
        key={id + "_check"}
        readOnly={true}
      />
      <span
        className="wrapper"
        onClick={() => {
          const propos = props;
          formikSetFieldValue(id, !value, extra);
        }}
      >
        <span className="knob"></span>
      </span>
    </span>
  );
}
